import axios from "axios"
export function toggleAdvertiserActive(token, advertiserId, newStatus) {
    return axios.get(process.env.REACT_APP_API_URL + `/toggleAdvertiserActive?advertiserId=${advertiserId}&advertiserNewStatus=${newStatus}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}